/** 拼接微服务真实路径（不含 Vite 开发代理前缀，代理前缀见 `VITE_API_PREFIX`） */
const createServiceBase = (service: string, module: string) => `/${service}/api/${module}`;

// 系统服务地址配置
export const SYSTEM_SERVICE_BASE = createServiceBase("service-chijing-system", "system");
// 系统服务-运营端模块地址配置
export const SYSTEM_OPS_BASE = createServiceBase("service-chijing-system", "ops");
// 用户服务地址配置
export const USERS_SERVICE_BASE = createServiceBase("service-chijing-users", "user");
// 用户服务-认证模块地址配置
export const USERS_AUTH_BASE = createServiceBase("service-chijing-users", "auth");
// 用户服务-运营端登录日志模块地址配置
export const USERS_OPS_LOGIN_LOG_BASE = createServiceBase("service-chijing-users", "ops/loginLog");
// 代理服务地址配置
export const AGENT_SERVICE_BASE = createServiceBase("service-chijing-agent", "agent");
// 代理服务-工商实体地址配置
export const AGENT_BUSINESS_BASE = createServiceBase("service-chijing-agent", "business");
// 门店服务地址配置
export const SHOP_SERVICE_BASE = createServiceBase("service-chijing-shop", "shop");
// 设备服务-运营端模块地址配置
export const DEVICE_OPS_BASE = createServiceBase("service-chijing-device", "ops/device");
// 会员服务-运营端模块地址配置
export const MEMBER_OPS_BASE = createServiceBase("service-chijing-member", "ops/member");
// 邀请服务地址配置
export const INVITATION_SERVICE_BASE = createServiceBase(
  "service-chijing-invitation",
  "invitation",
);
// 员工服务-OSS 模块地址配置
export const EMPLOYEE_OSS_BASE = createServiceBase("service-chijing-employee", "oss");
// 员工服务-OPS 模块地址配置
export const EMPLOYEE_OPS_BASE = createServiceBase("service-chijing-employee", "ops/employee");
// 员工服务-OPS 平台总部员工（选人下拉，不含代理/门店/供应商）
export const PLATFORM_EMPLOYEE_OPS_BASE = createServiceBase(
  "service-chijing-employee",
  "ops/platformEmployee",
);
// 员工服务-employee 模块地址配置
export const EMPLOYEE_BASE = createServiceBase("service-chijing-employee", "employee");
// SKU 服务-运营端模块地址配置
export const SKU_OPS_BASE = createServiceBase("service-chijing-sku", "ops/sku");
// SKU 服务-OSS 模块地址配置
export const SKU_OSS_BASE = createServiceBase("service-chijing-sku", "oss");
// IoT 服务-运营端模块地址配置
export const IOT_OPS_BASE = createServiceBase("service-chijing-iot", "iot/ops");
// 权益服务-运营端反馈工单模块地址配置
export const BENEFIT_OPS_FEEDBACK_BASE = createServiceBase(
  "service-chijing-benefit",
  "ops/benefit/feedback",
);
// 权益服务-运营端会员权益模块地址配置
export const BENEFIT_OPS_MEMBERS_BASE = createServiceBase(
  "service-chijing-benefit",
  "ops/benefit/members",
);

/**
 * 计费 HTTP baseURL：
 * - 开发（VITE_API_PREFIX=/api）：空串，走 Vite `/api/billing` → OPS 网关代理
 * - 测试/生产：直连 VITE_API_BASE_URL，得到 域名/api/billing/...
 */
export const BILLING_HTTP_BASE = import.meta.env.VITE_API_PREFIX?.trim()
  ? ""
  : import.meta.env.VITE_API_BASE_URL?.trim() || "";

/** 计费服务-OPS 会话：网关真实路径前缀（含 /api，配合 BILLING_HTTP_BASE，勿再叠默认 /api） */
export const BILLING_OPS_SESSION_BASE = "/api/billing/ops/session";

/** 计费服务-OPS PCT 错误日志：网关真实路径前缀（含 /api，配合 BILLING_HTTP_BASE） */
export const BILLING_OPS_PCT_LOG_BASE = "/api/billing/ops/pct-log";
